import { render } from "./index.vue?vue&type=template&id=48e3b0f5&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=48e3b0f5&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-48e3b0f5"

export default script